import { render, staticRenderFns } from "./ItemInformation.vue?vue&type=template&id=bf6d62aa&"
import script from "./ItemInformation.vue?vue&type=script&lang=ts&"
export * from "./ItemInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports